export { ExternalLinkAlt as default } from './ExternalLinkAlt';
